/* Progressive enhancement of the exact SSR page URLs. No card HTML renderer. */
(function () {
  'use strict';
  // 分類は、サーバーが描いたタブ（Python の archive_tabs()）から読む。企業特集を止めている間（config.COMPANIES_ENABLED）は
  // 「企業から探す」が描かれないので、ここにも入らない。タブが読めないときだけ既定の並びを使う。
  var TABS = ['series', 'companies', 'ai', 'development', 'business'];
  function norm(value) { return String(value || '').normalize('NFKC').toLocaleLowerCase('ja').trim(); }
  function initialize(root) {
    if (root.dataset.nmaInitialized) return;
    root.dataset.nmaInitialized = 'true';
    var view = root.querySelector('[data-nma-view]'), status = root.querySelector('[data-nma-status]');
    var form = root.querySelector('[data-nma-search-form]'), input = root.querySelector('[data-nma-search]');
    var loading = root.querySelector('[data-nma-loading]'), more = root.querySelector('[data-nma-more]');
    var retry = root.querySelector('[data-nma-retry]'), auto = root.querySelector('[data-nma-auto]');
    var initial = view.querySelector('[data-nma-page]');
    if (!initial) return;
    var drawnTabs = Array.prototype.map.call(initial.querySelectorAll('.nma-tabs a[data-nma-tab]'), function (anchor) { return anchor.dataset.nmaTab; });
    if (drawnTabs.length) TABS = drawnTabs;
    var index, ready = false, cache = new Map(), epoch = 0, controllers = new Set(), pending = false, retryAction;
    var state = { tab: initial.dataset.nmaTab, page: Number(initial.dataset.nmaNumber), start: Number(initial.dataset.nmaNumber), query: '', shown: 0, automatic: true };
    var matches = [], observer, scrollTimer, restoring = false, navigating = false;
    function url(value) {
      var target = new URL(value, location.origin);
      if (target.origin !== location.origin || target.pathname !== root.dataset.nmaHubPath || target.username || target.password) throw new Error('Unexpected archive URL');
      ['preview_theme_id', '_fd', 'pb'].forEach(function (key) { var current = new URL(location.href).searchParams.get(key); if (current) target.searchParams.set(key, current); });
      return target;
    }
    function decorate(scope) {
      scope.querySelectorAll('a[href]').forEach(function (anchor) {
        var target = new URL(anchor.getAttribute('href'), location.origin);
        if (target.origin !== location.origin) return;
        ['preview_theme_id', '_fd', 'pb'].forEach(function (key) { var current = new URL(location.href).searchParams.get(key); if (current) target.searchParams.set(key, current); });
        anchor.href = target.pathname + target.search + target.hash;
      });
    }
    function pageInfo(tab, number) {
      var page = index.pages[tab] && index.pages[tab][number - 1];
      if (!page || page.tab !== tab || page.page !== number) throw new Error('Unknown archive page');
      return page;
    }
    function validatePage(node, info) {
      if (!node || node.dataset.nmaHub !== 'news-matome' || node.dataset.nmaRevision !== index.revision || node.dataset.nmaTab !== info.tab || Number(node.dataset.nmaNumber) !== info.page) throw new Error('Archive page revision mismatch');
      // The whole fetched page fragment is inserted on tab changes. Validate
      // its navigation/headings too, including the outer article attributes.
      var allowedTags = ['DIV','NAV','A','SPAN','H2','H3','P','ARTICLE','IMG','TIME'];
      function imageUrl(value) { var image = new URL(value, location.origin); if (image.protocol !== 'https:' || (image.origin !== location.origin && image.hostname !== 'cdn.shopify.com') || image.username || image.password) throw new Error('Invalid archive image'); }
      [node].concat(Array.from(node.querySelectorAll('*'))).forEach(function (element) {
        if (!allowedTags.includes(element.tagName)) throw new Error('Unexpected archive element');
        Array.from(element.attributes).forEach(function (attribute) {
          if (!/^(?:class|href|src|srcset|sizes|alt|width|height|loading|decoding|datetime|tabindex|role|data-[a-z0-9-]+|aria-[a-z-]+)$/.test(attribute.name)) throw new Error('Unexpected archive attribute');
        });
        if (element.hasAttribute('src')) imageUrl(element.getAttribute('src'));
        if (element.hasAttribute('srcset')) element.getAttribute('srcset').split(',').forEach(function (candidate) { imageUrl(candidate.trim().split(/\s+/)[0]); });
        if (element.matches('a[href]') && !element.closest('[data-nma-card]')) url(element.getAttribute('href'));
      });
      var grid = node.querySelector('[data-nma-grid]');
      if (!grid || grid.querySelector('script,iframe,object,embed,form') || node.querySelectorAll('[data-nma-grid]').length !== 1) throw new Error('Invalid archive card region');
      var cards = Array.from(grid.children), ids = cards.map(function (card) { return card.dataset.nmaId; });
      if (cards.some(function (card) { return !card.matches('article[data-nma-card]'); }) || JSON.stringify(ids) !== JSON.stringify(info.ids)) throw new Error('Archive card membership changed; refresh the index');
      cards.forEach(function (card) {
        card.querySelectorAll('*').forEach(function (element) {
          Array.from(element.attributes).forEach(function (attribute) { if (/^on/i.test(attribute.name)) throw new Error('Unexpected executable card attribute'); });
        });
        card.querySelectorAll('a[href]').forEach(function (anchor) {
          var link = new URL(anchor.getAttribute('href'), location.origin);
          if (link.origin !== location.origin || !/^\/blogs\/media\/[a-z0-9-]+$/.test(link.pathname) || !link.pathname.includes('-news-matome')) throw new Error('Invalid archive article link');
        });
      });
      var next = node.querySelector('[data-nma-next]');
      if (Boolean(next) !== Boolean(info.next_url)) throw new Error('Archive next link mismatch');
      // プレビューでは Shopify がページ内のリンクに preview_theme_id などを付ける。付加の有無で食い違わないよう、
      // 引き継ぎ用のパラメータを外してから比べる（2026-09-29。外さないとプレビューで一覧の拡張が全部止まっていた）。
      function bare(target) { ['preview_theme_id', '_fd', 'pb'].forEach(function (key) { target.searchParams.delete(key); }); return target.pathname + target.search; }
      if (next) { var actual = url(next.getAttribute('href')), expected = url(info.next_url); if (bare(actual) !== bare(expected)) throw new Error('Unexpected archive next URL'); }
      return node;
    }
    function cancel() { epoch += 1; controllers.forEach(function (controller) { controller.abort(); }); controllers.clear(); pending = false; retry.hidden = true; retryAction = null; view.setAttribute('aria-busy', 'false'); return epoch; }
    async function fetchText(target, token, json) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 15000);
      controllers.add(controller);
      try {
        var response = await fetch(target, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: json ? 'application/json' : 'text/html' } });
        if (!response.ok) throw new Error('Archive request failed');
        if (response.url) { var finalUrl = new URL(response.url); if (!json && (finalUrl.origin !== location.origin || finalUrl.pathname !== root.dataset.nmaHubPath)) throw new Error('Archive request redirected'); }
        var result = json ? await response.json() : await response.text();
        if (token !== epoch) throw new Error('Obsolete request');
        return result;
      } finally { clearTimeout(timer); controllers.delete(controller); }
    }
    async function fetchPage(tab, number, token) {
      var info = pageInfo(tab, number), key = tab + ':' + number;
      if (cache.has(key)) return cache.get(key).cloneNode(true);
      var html = await fetchText(url(info.url).href, token, false);
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      if (parsed.querySelectorAll('[data-nma-page]').length !== 1) throw new Error('Archive response is not a page');
      var node = validatePage(parsed.querySelector('[data-nma-page]'), info);
      decorate(node); cache.set(key, node.cloneNode(true));
      return node.cloneNode(true);
    }
    function hasMore() { return state.query ? state.shown < matches.length : Boolean(pageInfo(state.tab, state.page).next_url); }
    function busy(value) { pending = value; view.setAttribute('aria-busy', String(value)); more.setAttribute('aria-disabled', String(value)); }
    function failure(error, action, token) {
      if (token !== epoch) return;
      busy(false); retryAction = action; retry.hidden = false;
      status.textContent = '読み込めませんでした。表示中の記事はそのまま読めます。再試行するか、次のページを開いてください。';
    }
    function update() {
      if (!index) return;
      loading.hidden = !hasMore(); more.hidden = !hasMore();
      var count = view.querySelectorAll('[data-nma-card]').length;
      var total = state.query ? matches.length : pageInfo(state.tab, state.page).total;
      var text = (state.query ? '検索結果 ' : '') + total + '件中 ' + count + '件を表示';
      var countNode = view.querySelector('[data-nma-count]');
      countNode.textContent = text;
      countNode.toggleAttribute('data-nma-searching', Boolean(state.query));
      status.textContent = text + (!hasMore() && total ? (state.start > 1 && !state.query ? '。このページ以降を表示しました。' : '。すべて表示しました。') : '');
      auto.setAttribute('aria-pressed', String(state.automatic));
      auto.textContent = state.automatic ? '自動読み込みを停止' : '自動読み込みを再開';
    }
    function remember(push) {
      if (!ready || restoring || navigating) return;
      var target = url(pageInfo(state.tab, state.query ? 1 : state.page).url);
      if (state.query) target.searchParams.set('q', input.value.trim());
      // 索引URLの組み直しでピークのパラメータを落とさない（スクロール中の replaceState を含む）
      if (peekOpen()) target.searchParams.set(peek.param, peek.handle());
      var saved = { revision: index.revision, tab: state.tab, page: state.page, start: state.start, query: state.query, searchValue: input.value, shown: state.shown, scrollY: window.scrollY };
      var nextState = Object.assign({}, history.state || {}, { nma: saved });
      history[push ? 'pushState' : 'replaceState'](nextState, '', target.pathname + target.search);
    }
    function replacePage(node) { view.replaceChildren(node); decorate(view); positionSwitcher(); }
    function appendPage(node, target) {
      target = target || view;
      var grid = target.querySelector('[data-nma-grid]'), current = new Set(Array.from(grid.children).map(function (card) { return card.dataset.nmaId; }));
      Array.from(node.querySelector('[data-nma-grid]').children).forEach(function (card) { if (!current.has(card.dataset.nmaId)) { grid.appendChild(card.cloneNode(true)); current.add(card.dataset.nmaId); } });
      target.querySelector('.nma-pagination').replaceWith(node.querySelector('.nma-pagination').cloneNode(true));
    }
    function searchMatches(current) { var terms = current.query.split(/\s+/).filter(Boolean); return index.items.filter(function (item) { return item.tabs.includes(current.tab) && terms.every(function (term) { return norm(item.text).includes(term); }); }); }
    async function appendSearch(token, target, current, selection) {
      target = target || view; current = current || state; selection = selection || matches;
      var chosen = selection.slice(current.shown, current.shown + index.page_size), cards = [];
      for (var item of chosen) {
        var info = index.pages[current.tab].find(function (page) { return page.ids.includes(item.id); });
        var node = await fetchPage(current.tab, info.page, token);
        cards.push(node.querySelector('[data-nma-id="' + item.id + '"]').cloneNode(true));
      }
      if (token !== epoch) return;
      target.querySelector('[data-nma-grid]').append.apply(target.querySelector('[data-nma-grid]'), cards);
      current.shown += cards.length;
    }
    async function loadMore(event) {
      if (!ready || pending || !retry.hidden || !hasMore()) return;
      var token = epoch, manual = event && event.type === 'click', previousCount = view.querySelectorAll('[data-nma-card]').length;
      busy(true);
      try {
        if (state.query) await appendSearch(token);
        else { var next = await fetchPage(state.tab, state.page + 1, token); if (token !== epoch) return; appendPage(next); state.page += 1; }
        if (token !== epoch) return;
        busy(false); update(); remember(false);
        if (manual && !hasMore()) { var newlyAdded = view.querySelectorAll('[data-nma-card]')[previousCount]; if (newlyAdded) newlyAdded.querySelector('[data-nma-article]').focus({ preventScroll: true }); }
      } catch (error) { failure(error, function () { return loadMore(manual ? { type: 'click' } : undefined); }, token); }
    }
    async function show(tab, number, query, push, restoration) {
      var token = cancel(), proposed = Object.assign({}, state, { tab: tab, query: query, page: query ? 1 : number, start: query ? 1 : number, shown: 0 });
      var focusTab = document.activeElement && document.activeElement.matches('a[data-nma-tab]');
      busy(true);
      try {
        var base = await fetchPage(tab, query ? 1 : number, token);
        if (token !== epoch) return;
        var selection = query ? searchMatches(proposed) : [];
        if (query) {
          base.querySelector('[data-nma-grid]').replaceChildren();
          base.querySelector('.nma-pagination').replaceChildren();
          var oldEmpty = base.querySelector('[data-nma-empty]'); if (oldEmpty) oldEmpty.remove();
          if (!selection.length) { var empty = document.createElement('p'); empty.className = 'nma-empty'; empty.dataset.nmaEmpty = ''; empty.textContent = '該当する記事はありません。検索語を変えてお試しください。'; base.querySelector('[data-nma-grid]').after(empty); }
        }
        // Prepare the entire replacement off-screen. A failed search or history
        // restore must not discard the readable old cards or change tab state.
        if (query) await appendSearch(token, base, proposed, selection);
        if (restoration && restoration.revision === index.revision) {
          if (query) { while (proposed.shown < Math.min(restoration.shown, selection.length)) await appendSearch(token, base, proposed, selection); }
          else { while (proposed.page < restoration.page) { appendPage(await fetchPage(tab, proposed.page + 1, token), base); proposed.page += 1; } }
        }
        if (token !== epoch) return;
        state = proposed; matches = selection; replacePage(base);
        if (focusTab) { var activeTab = view.querySelector('a[data-nma-tab="' + tab + '"]'); activeTab.focus({ preventScroll: true }); activeTab.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        busy(false); retry.hidden = true; update(); remember(push);
        if (restoration) requestAnimationFrame(function () { window.scrollTo(0, restoration.scrollY || 0); });
      } catch (error) { failure(error, function () { return show(tab, number, query, push, restoration); }, token); }
    }
    // ---------- サイドピーク ----------
    // 実体は共有モジュール（assets/news-matome-peek.js）。URLパラメータ ?nm_peek= を状態源にし、
    // 一覧側は「履歴URLでパラメータを落とさない」「ピークだけの履歴移動で一覧を作り直さない」を担う。
    var peek = window.NewsMatomePeek ? window.NewsMatomePeek.controller({ analytics: root.dataset.nmaPeekAnalytics === 'true' }) : null;
    function peekOpen() { return Boolean(peek && peek.isOpen()); }

    async function boot() {
      var token = cancel();
      ready = false;
      try {
        var searchUrl = new URL(root.dataset.nmaSearchUrl, location.origin);
        if (searchUrl.protocol !== 'https:' || (searchUrl.origin !== location.origin && searchUrl.hostname !== 'cdn.shopify.com')) throw new Error('Unexpected search asset URL');
        index = await fetchText(searchUrl.href, token, true);
        if (index.version !== 1 || index.hub_path !== root.dataset.nmaHubPath || index.page_size !== 12 || !/^[a-f0-9]{64}$/.test(index.revision) || !Array.isArray(index.items)) throw new Error('Invalid search index');
        var indexedIds = new Set();
        index.items.forEach(function (item) { if (!/^gid:\/\/shopify\/Article\/\d+$/.test(item.id) || indexedIds.has(item.id) || typeof item.text !== 'string' || !Array.isArray(item.tabs) || !item.tabs.length || item.tabs.some(function (tab) { return !TABS.includes(tab); })) throw new Error('Invalid searchable article'); indexedIds.add(item.id); });
        TABS.forEach(function (tab) { if (!Array.isArray(index.pages[tab]) || !index.pages[tab].length) throw new Error('Missing search tab'); index.pages[tab].forEach(function (info, i) { if (info.tab !== tab || info.page !== i + 1 || !Array.isArray(info.ids) || info.ids.length > 12 || new Set(info.ids).size !== info.ids.length) throw new Error('Invalid page membership'); url(info.url); if (info.next_url) url(info.next_url); }); });
        TABS.forEach(function (tab) { var ids = index.pages[tab].flatMap(function (page) { return page.ids; }); var expected = index.items.filter(function (item) { return item.tabs.includes(tab); }).map(function (item) { return item.id; }); if (JSON.stringify(ids) !== JSON.stringify(expected)) throw new Error('Search and page identities disagree'); });
        validatePage(initial, pageInfo(initial.dataset.nmaTab, Number(initial.dataset.nmaNumber)));
        decorate(initial); cache.set(state.tab + ':' + state.page, initial.cloneNode(true));
        ready = true; form.hidden = false; retry.hidden = true; busy(false);
        // 復元より先にピークを開く。以後の remember() がパラメータを保持できる状態にしてから
        // 一覧の復元へ進む（共有URLで着地した瞬間に剥がれるのを防ぐ）。
        if (peek) peek.syncFromUrl();
        var params = new URL(location.href).searchParams, tab = params.get('nm_tab');
        var saved = history.state && history.state.nma;
        if (saved && saved.revision === index.revision && TABS.includes(saved.tab)) {
          input.value = saved.searchValue || ''; restoring = true;
          try { await show(saved.tab, saved.start || 1, saved.query || '', false, saved); } finally { restoring = false; }
        } else if (params.get('q') || (TABS.includes(tab) && tab !== state.tab)) {
          input.value = params.get('q') || ''; await show(TABS.includes(tab) ? tab : state.tab, 1, norm(input.value), false);
        } else { update(); remember(false); }
        if (!observer && 'IntersectionObserver' in window) { observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; }) && state.automatic && !peekOpen()) loadMore(); }, { rootMargin: '250px' }); observer.observe(root.querySelector('[data-nma-sentinel]')); }
      } catch (error) { if (token === epoch) { ready = false; index = null; form.hidden = true; loading.hidden = true; } failure(error, boot, token); }
    }
    decorate(root);
    root.addEventListener('click', function (event) {
      var tab = event.target.closest('a[data-nma-tab]');
      if (tab && ready && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault(); remember(false); input.value = '';
        // 追従しているタブ列から切り替えたときは、新しい分類の先頭（タブ列の元の位置）へ戻す（2026-09-29）。
        // 一覧の上のほうで押したときは動かさない。
        show(tab.dataset.nmaTab, 1, '', true).then(function () {
          if (window.scrollY > listTop() + 1) { scrollToTabs(); setTimeout(function () { remember(false); }, 450); }
        });
      }
      // カード内のリンクはすべてサイドピークで開く。href は実URLのまま残すのでクローラは
      // 記事URLを辿れる。自動実行のクリック（isTrusted=false）では開かない。
      var card = event.target.closest('[data-nma-card] a[href]');
      if (card && suppressClick) { event.preventDefault(); return; }
      if (card && ready && peek && event.isTrusted && !event.defaultPrevented && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
        var opened = peek.handleFromHref(card.getAttribute('href'));
        if (opened && peek.open(opened, card)) { event.preventDefault(); return; }
      }
      var link = event.target.closest('a[href]');
      if (link && !event.defaultPrevented && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) { remember(false); navigating = true; clearTimeout(scrollTimer); }
    });
    // ---------- フリックでタブを切り替える ----------
    // 無限スクロールで下方にいることが多いため、切り替えたらタブ列まで戻す。
    var SWIPE_MIN = 55, SWIPE_RATIO = 1.6, SWIPE_MS = 700, DRAG_MIN = 90, WHEEL_MIN = 120, swipeStart = null;
    var switcher = root.querySelector('[data-nma-switcher]'), rail = root.querySelector('[data-nma-rail]');
    var SWIPE_EXCLUDE = '.nma-tabs, .nma-search, .nma-loading, button, input, select, textarea';
    function positionSwitcher() {
      // 矢印は先頭カードの画像に重ねる。フリックの対象がカードなので、操作できる場所と
      // 矢印の位置を一致させる。カードが無い分類ではタブ列の高さへ戻す。
      if (!switcher || !rail) return;
      var anchor = view.querySelector('[data-nma-card] .nma-card-image') || view.querySelector('[data-nma-card]') || view.querySelector('.nma-tabs');
      if (!anchor) return;
      var top = anchor.getBoundingClientRect().top - rail.getBoundingClientRect().top + anchor.offsetHeight / 2;
      rail.style.setProperty('--nma-switch-top', Math.round(top) + 'px');
    }
    function revealActiveTab() {
      // タブ列は横スクロールなので、切り替えた先が画面外に出たままにならないよう寄せる。
      var strip = view.querySelector('.nma-tabs');
      var active = strip && strip.querySelector('a[aria-current="page"]');
      if (!strip || !active || strip.scrollWidth <= strip.clientWidth) return;
      var target = Math.max(0, active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2);
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { strip.scrollTo({ left: target, behavior: still ? 'auto' : 'smooth' }); }
      catch (error) { strip.scrollLeft = target; }
    }
    function stickyOffset() {
      // 追従ヘッダーがあるとタブ列が隠れるため、その高さぶん手前で止める。
      var found = 0;
      document.querySelectorAll('header, .tds-header, [class*="header"]').forEach(function (element) {
        var style = window.getComputedStyle(element);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        var box = element.getBoundingClientRect();
        // いま画面上端を覆っているものだけを追従ヘッダーとみなす。スクロールで流れ去る
        // sticky ヘッダーを固定扱いにすると、余白だけが残ってしまう。
        if (box.height && box.top <= 1 && box.bottom > 1) found = Math.max(found, box.bottom);
      });
      return Math.min(found, 160) + 12;
    }
    var stickyFrame = null, stickyValue = null;
    function requestStickySync() {
      if (stickyFrame) return;
      stickyFrame = requestAnimationFrame(function () { stickyFrame = null; syncStickyTop(); });
    }
    function syncStickyTop() {
      // タブ列は position:sticky。追従ヘッダーの下で止まるよう、その高さを変数へ入れる。
      var value = Math.max(0, stickyOffset() - 12);
      if (value === stickyValue) return;
      stickyValue = value;
      document.documentElement.style.setProperty('--nma-sticky-top', value + 'px');
    }
    function listTop() {
      // タブ列は追従（position:sticky）なので、止まっている位置ではなく、一覧の外枠（タブ列の元の位置）を基準にする。
      // タブ列そのものの位置で測ると、追従中は「今いる位置」になり、戻らない（2026-09-29 に実際に起きた）。
      return Math.max(0, view.getBoundingClientRect().top + window.scrollY - stickyOffset());
    }
    function scrollToTabs() {
      var top = listTop();
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { window.scrollTo({ top: top, behavior: still ? 'auto' : 'smooth' }); }
      catch (error) { window.scrollTo(0, top); }
    }
    function swipeTab(direction) {
      if (!ready || peekOpen() || pending) return;
      var current = TABS.indexOf(state.tab);
      if (current < 0) return;
      var next = TABS[(current + direction + TABS.length) % TABS.length];
      if (next === state.tab) return;
      remember(false);
      input.value = '';
      show(next, 1, '', true).then(function () {
        scrollToTabs();
        revealActiveTab();
        // 履歴には切替前のスクロール位置が入っているため、移動後の位置で取り直す。
        setTimeout(function () { remember(false); }, 450);
      });
    }
    root.addEventListener('touchstart', function (event) {
      swipeStart = null;
      if (event.touches.length !== 1 || peekOpen() || !ready) return;
      // タブ列は横スクロール、フォーム操作は入力なのでフリック判定から外す。
      if (event.target.closest(SWIPE_EXCLUDE)) return;
      var touch = event.touches[0];
      // iOS の画面端スワイプ（戻る操作）と二重発火しないよう、端24pxからの開始は無視する。
      if (touch.clientX <= 24 || touch.clientX >= window.innerWidth - 24) return;
      swipeStart = { x: touch.clientX, y: touch.clientY, at: Date.now() };
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      var start = swipeStart;
      swipeStart = null;
      if (!start || !event.changedTouches.length || Date.now() - start.at > SWIPE_MS) return;
      var touch = event.changedTouches[0], dx = touch.clientX - start.x, dy = touch.clientY - start.y;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * SWIPE_RATIO) return;
      swipeTab(dx < 0 ? 1 : -1);
    }, { passive: true });
    root.addEventListener('touchcancel', function () { swipeStart = null; }, { passive: true });
    // トラックパッドの横スクロール（および Shift+ホイール）でも切り替える。
    // 既定動作を止めないとブラウザの「戻る/進む」ジェスチャと二重に反応する。
    var wheelDelta = 0, wheelTimer = null, wheelLock = false;
    root.addEventListener('wheel', function (event) {
      if (!ready || peekOpen()) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      if (event.target.closest('.nma-tabs, .nma-search, input, textarea, select')) return;
      event.preventDefault();
      if (wheelLock) return;
      wheelDelta += event.deltaX;
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () { wheelDelta = 0; }, 220);
      if (Math.abs(wheelDelta) < WHEEL_MIN) return;
      var direction = wheelDelta > 0 ? 1 : -1;
      wheelDelta = 0;
      wheelLock = true;
      setTimeout(function () { wheelLock = false; }, 700);
      swipeTab(direction);
    }, { passive: false });

    // PCではドラッグ（マウス・ペン）でも切り替える。タッチは上の touch* が担当する。
    var drag = null, suppressClick = false;
    function dragTarget(event) { return event.target.closest ? event.target.closest(SWIPE_EXCLUDE) : null; }
    root.addEventListener('pointerdown', function (event) {
      drag = null;
      if (event.pointerType === 'touch' || event.button !== 0 || !ready || peekOpen()) return;
      if (dragTarget(event)) return;
      if (event.clientX <= 24 || event.clientX >= window.innerWidth - 24) return;
      drag = { x: event.clientX, y: event.clientY, at: Date.now(), moved: false };
    });
    root.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.moved && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) drag.moved = true;
      // 横へ動かし始めたら、文字選択とリンクのドラッグ開始を抑える。
      if (drag.moved) event.preventDefault();
    }, { passive: false });
    root.addEventListener('pointerup', function (event) {
      var start = drag;
      drag = null;
      if (!start || !start.moved) return;
      // 横へ引きずった後の click は「記事を開く」意図ではないので、切替に届かない距離でも握りつぶす。
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 0);
      if (Date.now() - start.at > 900) return;
      var dx = event.clientX - start.x, dy = event.clientY - start.y;
      if (Math.abs(dx) < DRAG_MIN || Math.abs(dx) < Math.abs(dy) * SWIPE_RATIO) return;
      swipeTab(dx < 0 ? 1 : -1);
    });
    root.addEventListener('pointercancel', function () { drag = null; });
    root.addEventListener('dragstart', function (event) { if (drag) event.preventDefault(); });

    form.addEventListener('submit', function (event) { event.preventDefault(); if (ready) show(state.tab, 1, norm(input.value), true); });
    root.querySelector('[data-nma-reset]').addEventListener('click', function () { input.value = ''; if (ready) show(state.tab, 1, '', true); input.focus(); });
    syncStickyTop();
    if (switcher) {
      switcher.hidden = false;
      positionSwitcher();
      switcher.querySelectorAll('[data-nma-switch]').forEach(function (button) {
        button.addEventListener('click', function () { swipeTab(Number(button.dataset.nmaSwitch)); });
      });
      var switcherTimer = null;
      window.addEventListener('resize', function () { clearTimeout(switcherTimer); switcherTimer = setTimeout(function () { positionSwitcher(); syncStickyTop(); }, 120); });
      window.addEventListener('load', function () { positionSwitcher(); syncStickyTop(); });
    }
    more.addEventListener('click', loadMore);
    retry.addEventListener('click', function () { var action = retryAction; retry.hidden = true; if (action) action(); });
    auto.addEventListener('click', function () { state.automatic = !state.automatic; update(); if (state.automatic) loadMore(); });
    window.addEventListener('scroll', function () { requestStickySync(); clearTimeout(scrollTimer); scrollTimer = setTimeout(function () { remember(false); }, 150); }, { passive: true });
    // Never rewrite history during pagehide: that can cancel an in-progress
    // native link navigation. Click/scroll persist it while this page is active.
    window.addEventListener('pageshow', function () { navigating = false; });
    window.addEventListener('popstate', function (event) {
      if (!ready) return;
      // ピークの同期は共有モジュール側のリスナーが先に済ませている。
      var saved = event.state && event.state.nma, params = new URL(location.href).searchParams;
      var tab = saved && saved.tab || params.get('nm_tab') || 'series'; if (!TABS.includes(tab)) tab = 'series';
      var value = saved && saved.searchValue || params.get('q') || '';
      // ピークの開閉だけの履歴移動では一覧を作り直さない。作り直すとカードDOMが差し替わり、
      // フォーカスの戻り先とスクロール位置が失われる。
      if (tab === state.tab && norm(value) === state.query && (saved && saved.start || 1) === state.start) return;
      input.value = value;
      restoring = true;
      show(tab, saved && saved.start || 1, norm(value), false, saved).finally(function () { restoring = false; });
    });
    boot();
  }
  document.querySelectorAll('[data-nma-root]').forEach(initialize);
}());
